import { useInView } from "react-intersection-observer";

const steps = [
	{
		n: "1",
		text: "Lembaga menyediakan lokasi kandang dan tenaga pengelola sebagai bentuk wakaf produktif",
	},
	{
		n: "2",
		text: "NusaQu menyediakan bibit ternak, pakan, sistem, dan manajemen peternakan profesional",
	},
	{
		n: "3",
		text: "Hasil usaha ternak dibeli kembali oleh NusaQu — pasar terjamin, manfaat wakaf berkelanjutan",
	},
];

const links = [
	{ icon: "🌐", label: "nusaqu.id", href: "https://nusaqu.id" },
	{
		icon: "🤝",
		label: "nusaqu.id/kemitraan",
		href: "https://nusaqu.id/kemitraan",
	},
	{ icon: "🛍️", label: "shop.nusaqu.id", href: "https://shop.nusaqu.id" },
	{ icon: "🏠", label: "www.nusaqu.id", href: "https://www.nusaqu.id" },
];

export default function WakafProduktif() {
	const { ref: lRef, inView: lIn } = useInView({
		threshold: 0.1,
		triggerOnce: true,
	});
	const { ref: rRef, inView: rIn } = useInView({
		threshold: 0.1,
		triggerOnce: true,
	});

	return (
		<section id="wakaf" style={styles.section}>
			<div className="grid-2col-wakaf" style={styles.wrap}>
				{/* Left box */}
				<div
					ref={lRef}
					style={{
						...styles.leftBox,
						opacity: lIn ? 1 : 0,
						transform: lIn ? "translateY(0)" : "translateY(28px)",
						transition: "all 0.65s 0.1s",
					}}>
					<div style={styles.portalTitle}>Portal &amp; Link Resmi</div>
					{links.map((l) => (
						<a
							key={l.href}
							href={l.href}
							target="_blank"
							rel="noreferrer"
							style={styles.wlink}
							onMouseEnter={(e) => {
								e.currentTarget.style.background = "rgba(255,255,255,.15)";
								e.currentTarget.style.borderColor = "rgba(255,255,255,.3)";
							}}
							onMouseLeave={(e) => {
								e.currentTarget.style.background = "rgba(255,255,255,.06)";
								e.currentTarget.style.borderColor = "rgba(255,255,255,.12)";
							}}>
							{l.icon} {l.label}
						</a>
					))}
					<div style={styles.skema}>
						<div style={styles.skemaTitle}>Skema Kolaborasi</div>
						<p style={styles.skemaText}>
							Lembaga menyediakan lokasi/kandang + tenaga pengelola. NusaQu
							menyediakan bibit, pakan, sistem, dan manajemen profesional. Hasil
							usaha dibeli kembali oleh NusaQu — pasar terjamin.
						</p>
					</div>
				</div>

				{/* Right */}
				<div
					ref={rRef}
					style={{
						opacity: rIn ? 1 : 0,
						transform: rIn ? "translateY(0)" : "translateY(28px)",
						transition: "all 0.65s",
					}}>
					<div>
						<span style={styles.lbl}>Wakaf Produktif</span>
					</div>
					<h2 style={styles.h2}>
						Wakaf yang Menghasilkan Manfaat Berkelanjutan
					</h2>
					<p style={styles.desc}>
						Wakaf dikelola secara produktif melalui usaha peternakan NusaQu —
						memastikan manfaat wakaf terus mengalir dan pasar hasil ternak
						selalu terjamin.
					</p>
					<div>
						{steps.map((s) => (
							<div key={s.n} style={styles.step}>
								<div style={styles.stepNum}>{s.n}</div>
								<div style={styles.stepText}>{s.text}</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}

const styles = {
	section: {
		background: "linear-gradient(135deg, var(--coklat) 0%, #5A2E00 100%)",
		padding: "6rem 5%",
	},
	wrap: {
		maxWidth: "1080px",
		margin: "0 auto",
		display: "grid",
		gridTemplateColumns: "0.85fr 1.15fr",
		gap: "4rem",
		alignItems: "center",
	},
	leftBox: {
		background: "rgba(255,255,255,.07)",
		border: "1px solid rgba(255,255,255,.12)",
		borderRadius: "20px",
		padding: "2rem",
	},
	portalTitle: {
		color: "rgba(255,255,255,.55)",
		fontSize: "0.75rem",
		fontWeight: 700,
		letterSpacing: "2px",
		textTransform: "uppercase",
		marginBottom: "1rem",
	},
	wlink: {
		display: "flex",
		alignItems: "center",
		gap: "0.5rem",
		background: "rgba(255,255,255,.06)",
		border: "1px solid rgba(255,255,255,.12)",
		borderRadius: "8px",
		padding: "0.6rem 0.9rem",
		marginBottom: "0.5rem",
		textDecoration: "none",
		color: "rgba(255,255,255,.85)",
		fontSize: "0.85rem",
		fontWeight: 600,
		transition: "all 0.25s",
	},
	skema: {
		background: "rgba(240,165,0,.12)",
		border: "1px solid rgba(240,165,0,.25)",
		borderRadius: "10px",
		padding: "1rem",
		marginTop: "1rem",
	},
	skemaTitle: {
		color: "var(--kuning2)",
		fontSize: "0.8rem",
		fontWeight: 700,
		marginBottom: "0.4rem",
	},
	skemaText: {
		color: "rgba(255,255,255,.7)",
		fontSize: "0.82rem",
		lineHeight: 1.7,
	},
	lbl: {
		display: "inline-block",
		background: "var(--kuning)",
		color: "var(--coklat)",
		padding: "0.28rem 0.95rem",
		borderRadius: "2rem",
		marginBottom: "1rem",
		fontSize: "0.72rem",
		fontWeight: 800,
		letterSpacing: "3px",
		textTransform: "uppercase",
	},
	h2: {
		fontFamily: "Lora, serif",
		fontSize: "clamp(1.6rem, 3vw, 2.5rem)",
		fontWeight: 700,
		color: "white",
		marginBottom: "0.9rem",
	},
	desc: {
		color: "rgba(255,255,255,.65)",
		fontSize: "0.95rem",
		lineHeight: 1.8,
		marginBottom: "1.8rem",
	},
	step: {
		display: "flex",
		gap: "1rem",
		alignItems: "flex-start",
		marginBottom: "1.1rem",
	},
	stepNum: {
		width: "36px",
		height: "36px",
		minWidth: "36px",
		background: "var(--kuning)",
		borderRadius: "50%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		fontWeight: 800,
		fontSize: "0.9rem",
		color: "var(--coklat)",
	},
	stepText: {
		color: "rgba(255,255,255,.8)",
		fontSize: "0.92rem",
		lineHeight: 1.7,
		paddingTop: "0.45rem",
	},
};
